<template>
	<Head title="Finalizar matrícula" />
	<h4 class="text-center mb-5" id="title">
		Para finalizar o processo de matrícula, é necessário aceitar os termos
		de uso e atualizar sua foto.
	</h4>

	<div id="smartwizard">
		<ul class="nav">
			<li class="nav-item">
				<a class="nav-link" href="#step-1">
					<div class="num">1</div>
					Termos e Condições
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" href="#step-2">
					<span class="num">2</span>
					Foto
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" href="#step-3">
					<span class="num">3</span>
					Finalizar
				</a>
			</li>
		</ul>

		<div class="tab-content">
			<div
				id="step-1"
				class="tab-pane p-5"
				role="tabpanel"
				aria-labelledby="step-1">
				<div
					style="height: 200px; overflow: scroll; overflow-x: hidden"
					id="terms_text">
					<iframe
						src="/terms-and-conditions"
						class="mb-5"
						frameborder="0"
						width="100%"></iframe>
					<div class="row">
						<div class="col-12 col-md-4 d-flex align-items-center">
							<input
								type="checkbox"
								id="terms_and_conditions"
								v-model="form.terms" />
							<label for="terms_and_conditions" class="ms-2"
								>Declaro que li e aceito os termos e condições.
							</label>
						</div>
						<div
							class="col-12 col-md-8 d-flex align-items-center justify-content-start">
							<span
								class="text-danger fw-bold ms-2"
								v-if="terms_error"
								id="terms_error">
								{{ terms_error_message }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div
				id="step-2"
				class="tab-pane p-5"
				role="tabpanel"
				aria-labelledby="step-2">
				<div class="row p-5">
					<div class="col-12 col-md-6 d-flex align-items-center">
						<div class="d-block">
							<ul>
								<li>
									Para bater a foto será necessário que o seu
									navegador tenha permissão para acessar a
									câmera.
								</li>
								<li>
									Certifique-se que somente você apareça na
									foto.
								</li>
								<li>
									Mantenha a
									<u style="color: #022d62">CABEÇA RETA</u> e
									o
									<u style="color: #022d62">OLHAR FIXO</u>
									para a câmera.
								</li>
								<li>
									Retire qualquer acessório que oculte
									<u style="color: #022d62"> PARCIAL </u> ou
									<u style="color: #022d62">TOTALMENTE</u> seu
									<u style="color: #022d62"> ROSTO</u>.
								</li>
								<li>
									Realize a captura clicando em
									<u style="color: #022d62">CAPTURAR FOTO</u>.
								</li>
							</ul>
							<h4
								id="photo_error"
								class="text-danger fw-bolder text-center mt-15 text-uppercase"
								v-if="photo_error">
								Erro: {{ photo_error_messsage }}
							</h4>
						</div>
					</div>
					<div
						class="col-12 col-md-6 d-flex justify-content-center"
						id="student-photo">
						<div class="box-camera text-center">
							<div id="foto" class="rounded" v-if="form.photo">
								<img
									style="width: 250px; height: 250px"
									:src="
										'data:image/jpeg;base64,' + form.photo
									" />
							</div>
							<div id="camera" class="rounded" v-else>
								<img
									v-if="mock_student_photo"
									class="img-photo"
									:src="
										'data:image/jpeg;base64,' +
										props.mock_photo_b64
									" />
							</div>
						</div>
					</div>
					<div class="row col-12 col-md-6 offset-md-6">
						<button
							v-if="checking_photo"
							class="btn btn-primary mt-3"
							type="button"
							disabled>
							<span
								class="spinner-border spinner-border-sm mt-1"
								role="status"
								aria-hidden="true"></span>
							<span class="ms-6">Validando foto</span>
						</button>
						<button
							v-else-if="!form.photo"
							@click="capturePhoto"
							id="camera-take-snapshot"
							class="btn btn-primary m-2">
							<i class="fa fa-camera"></i> Capturar foto
						</button>
						<button
							v-else
							@click="retryPhoto"
							id="camera-retry-snapshot"
							class="btn btn-warning m-2">
							<i class="fa fa-sync"></i> Descartar e tentar
							novamente
						</button>
						<p
							id="photo_success_message"
							class="text-success fw-bolder"
							v-if="form.photo">
							Foto aprovada na validação !
						</p>
					</div>
				</div>
			</div>
			<div
				id="step-3"
				class="tab-pane"
				role="tabpanel"
				aria-labelledby="step-3"
				style="height: 200px">
				<h4 class="text-center mt-5" v-if="!loading && !success">
					Para concluir o cadastro clique em enviar.
				</h4>
				<div v-if="loading">
					<h5 class="text-center mt-5">
						Aguarde um instânte em quanto nós validamos seus
						dados...
					</h5>
					<div class="d-flex justify-content-center mt-3">
						<div
							id="spinner"
							class="spinner-border spinner-border-xl"
							style="color: coral; z-index: 2; position: relative"
							role="status">
							<span class="sr-only"> Carregando... </span>
						</div>
					</div>
				</div>
				<div v-if="success" id="success_message">
					<h4 class="text-success text-center mt-5">
						Cadastro atualizado com sucesso !
					</h4>
					<h5 class="text-center">
						<a :href="props.login_route">Clique aqui</a> para fazer
						login na plataforma.
					</h5>
				</div>
				<div v-if="success !== null && !success" id="fail_message">
					<h4 class="text-danger text-center mt-5">
						Ocorreu um erro ao concluir a operação !
					</h4>
					<h5 class="text-center">Erro: {{ response_error }}</h5>
				</div>
			</div>
		</div>

		<div class="progress">
			<div
				class="progress-bar"
				role="progressbar"
				style="width: 0%"
				aria-valuenow="0"
				aria-valuemin="0"
				aria-valuemax="100"></div>
		</div>
	</div>

	<div class="row mt-3" v-if="!success">
		<div class="col-12 col-md-6 d-grid gap-2">
			<button
				id="prev-step"
				v-if="!loading && tab > 0"
				class="btn tab-button mb-3 mb-md-0"
				type="button"
				@click="previousStep">
				Anterior
			</button>
		</div>
		<div class="col-12 col-md-6 d-grid gap-2">
			<button
				id="submit"
				v-if="tab === 2 && !loading"
				class="btn btn-success"
				type="button"
				@click="submit">
				Enviar
			</button>
			<button
				id="next-step"
				v-else-if="tab !== 2 && !loading"
				class="btn tab-button"
				type="button"
				@click="nextStep">
				Próximo
			</button>
		</div>
	</div>
</template>

<script lang="ts">
	import { Ref, onMounted, ref, watch } from 'vue';
	import Layout from '../../Layouts/simple_layout.vue';
	import { Head, usePage } from '@inertiajs/vue3';
	import axios from 'axios';

	export default {
		components: {
			Head,
		},
		layout: Layout,
	};
</script>

<script setup lang="ts">
	const props = defineProps({
		mock_photo_b64: { type: String, required: true },
		store_student_photo_url: { type: String, required: true },
		enrollment_id: { type: Number, required: true },
		login_route: { type: String, required: true },
		student_photo_compatibility_url: { type: String, required: true },
		api_token: { type: String, required: true },
	});

	const form = ref({
		terms: false,
		photo: null as string | null,
	});

	const tab = ref(0);
	const terms_error = ref(false);
	const terms_error_message =
		'É obrigatório aceitar os termos para continuar !';
	const photo_error = ref(false);
	const photo_error_messsage = ref('');

	const mock_student_photo = usePage().props?.mock_user_photo as boolean;

	const loading = ref(false);
	const success = ref(null) as Ref<boolean> | Ref<null>;
	const response_error = ref('');
	const checking_photo = ref(false);

	watch(
		() => form.value.photo,
		(value) => {
			if (value) {
				photo_error.value = false;
			}
		}
	);

	watch(
		() => form.value.terms,
		(value) => {
			if (value) {
				terms_error.value = false;
			}
		}
	);

	$(function () {
		// SmartWizard initialize
		$('#smartwizard').smartWizard({
			selected: tab.value,
			theme: 'arrows',
			lang: { next: 'Próximo', previous: 'Anterior' },
			enableUrlHash: false,
			anchor: {
				enableNavigation: false, // Enable/Disable anchor navigation
				enableNavigationAlways: false, // Activates all anchors clickable always
				enableDoneState: true, // Add done state on visited steps
				markPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
				unDoneOnBackNavigation: true, // While navigate back, done state will be cleared
				enableDoneStateNavigation: true, // Enable/Disable the done state navigation
			},
			toolbar: {
				position: 'bottom', // none|top|bottom|both
				showNextButton: false, // show/hide a Next button
				showPreviousButton: false, // show/hide a Previous button
			},
			keyboard: {
				keyNavigation: false, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
			},
		});
	});

	function nextStep() {
		if (tab.value < 2 && validate()) {
			tab.value++;
			$('#smartwizard').smartWizard('next');
		}
	}

	function previousStep() {
		if (tab.value > 0) {
			tab.value--;
		}
		$('#smartwizard').smartWizard('prev');
	}

	function validate(): boolean {
		if (!form.value.terms && tab.value === 0) {
			terms_error.value = true;
			return false;
		}
		if (!form.value.photo && tab.value === 1) {
			photo_error_messsage.value =
				'É obrigatório bater a foto para continuar !';
			photo_error.value = true;
			return false;
		}
		return true;
	}

	function attachWebcam(container) {
		window.Webcam.set({
			width: 400,
			height: 300,
			image_format: 'jpeg',
			jpeg_quality: 100,
		});

		window.Webcam.attach(container);
	}

	function submit() {
		loading.value = true;
		axios
			.post(
				props.store_student_photo_url,
				{
					terms: form.value.terms,
					photo: form.value.cropped,
					enrollment_id: props.enrollment_id,
				},
				{
					headers: { Authorization: props.api_token },
				}
			)
			.then((response) => {
				success.value = true;
				loading.value = false;
			})
			.catch((response) => {
				response_error.value = response.response.data.message;
				success.value = false;
				loading.value = false;
			});
	}

	function capturePhoto() {
		checking_photo.value = true;

		takeSnapshot().then((responseCamera) => {
			axios
				.post(
					props.student_photo_compatibility_url,
					{
						photo: responseCamera.base64,
						enrollment_id: props.enrollment_id,
					},
					{
						headers: { Authorization: props.api_token },
					}
				)
				.then((response) => {
					checking_photo.value = false;
					form.value.photo = responseCamera.base64;
					form.value.cropped = response.data.photo_cropped;
				})
				.catch((response) => {
					photo_error_messsage.value = response.response.data.message;
					photo_error.value = true;
					checking_photo.value = false;
				});
		});
	}

	function retryPhoto() {
		form.value.photo = null;
		if (!mock_student_photo) {
			resetWebcam().then(() => {
				attachWebcam('#camera');
			});
		}
	}

	onMounted(() => {
		if (!mock_student_photo) {
			attachWebcam('#camera');
		}
	});
</script>

<style>
	.tab-button {
		background-color: #ff662a;
		color: #fff;
	}

	.tab-button:hover {
		background-color: #ff500a;
		color: #fff;
	}

	.tab-content {
		height: 100% !important;
	}

	#camera {
		width: 100% !important;
		height: 100% !important;
		overflow: hidden;
		display: flex;
		justify-content: center;
		border-radius: 0.475rem;
	}

	.img-photo {
		width: 60%;
		height: 85%;
		border-radius: 50%;
		box-shadow:
			rgb(255, 102, 42) 0px 0px 0px 5px,
			rgb(255, 255, 255) 0px 0px 0px 0px;
	}

	.box-camera {
		width: 200px;
		height: 100%;
		border-radius: 50%;
		box-shadow:
			rgb(255, 102, 42) 0px 0px 0px 5px,
			rgb(255, 255, 255) 0px 0px 0px 0px;
		overflow: hidden;
		align-items: center;
	}

	:root {
		--sw-anchor-active-primary-color: #ff662a;
		--sw-anchor-done-primary-color: #fab59a;
		--sw-progress-color: #ff662a;
	}
</style>
